import {
  payoutSetupView,
  payoutSetupPage,
  payoutSetupHistory,
  type PayoutSetupAdminActionInput,
  type PayoutSetupQuery,
} from '@dental-staffing-platform/shared';
import { req } from './admin-client.js';
export const payoutAdminClient = {
  list: async (query: PayoutSetupQuery) => {
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(query))
      if (value !== undefined && value !== '') params.set(key, String(value));
    return payoutSetupPage.parse(await req(`/api/admin/payout-onboarding?${params}`));
  },
  get: async (id: string) =>
    payoutSetupView.parse(await req(`/api/admin/payout-onboarding/${encodeURIComponent(id)}`)),
  history: async (id: string, page: number) =>
    payoutSetupHistory.parse(
      await req(
        `/api/admin/payout-onboarding/${encodeURIComponent(id)}/history?page=${page}&pageSize=10`
      )
    ),
  act: async (id: string, input: PayoutSetupAdminActionInput) =>
    payoutSetupView.parse(
      await req(`/api/admin/payout-onboarding/${encodeURIComponent(id)}/events`, {
        method: 'POST',
        body: JSON.stringify(input),
      })
    ),
};
